import { render, staticRenderFns } from "./StaffAndPayroll.vue?vue&type=template&id=17c20b86&scoped=true"
import script from "./StaffAndPayroll.vue?vue&type=script&lang=js"
export * from "./StaffAndPayroll.vue?vue&type=script&lang=js"
import style0 from "./StaffAndPayroll.vue?vue&type=style&index=0&id=17c20b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c20b86",
  null
  
)

export default component.exports